export default "__VITE_ASSET__cb9748a4__"